import { TApplicationState } from '../../types/redux';
import { ILayoutRoomCount as IWidgetLayoutRoomCount, ERoomType } from '@cian/frontend-newbuilding-layouts-widget';
import { ILayoutRoomCount } from '../../types/newbuilding/layoutInfo';

export enum ERoomValue {
  'FourPlusRoom' = 'fourPlusRoom',
  'OneRoom' = 'oneRoom',
  'Studio' = 'studio',
  'ThreeRoom' = 'threeRoom',
  'TwoRoom' = 'twoRoom',
}

const ROOM_TYPE_MAP: { [key in ERoomValue]: ERoomType } = {
  [ERoomValue.Studio]: ERoomType.Studio,
  [ERoomValue.OneRoom]: ERoomType.OneRoom,
  [ERoomValue.TwoRoom]: ERoomType.TwoRoom,
  [ERoomValue.ThreeRoom]: ERoomType.ThreeRoom,
  [ERoomValue.FourPlusRoom]: ERoomType.FourRoom,
};

export const roomsCountListSelector = (houseId?: number) => (state: TApplicationState) => {
  if (!state.newbuilding.roomsCountsByHouse) {
    return [];
  }

  const roomsCountsByHouse = state.newbuilding.roomsCountsByHouse.find(rooms =>
    houseId ? rooms.houseId === houseId : !rooms.houseId,
  );

  if (!roomsCountsByHouse) {
    return [];
  }

  // Проблема с типизацией enum
  return roomCountMapper(roomsCountsByHouse.roomsCountList as unknown as ILayoutRoomCount[]);
};

function roomCountMapper(rooms: ILayoutRoomCount[]): IWidgetLayoutRoomCount[] {
  return rooms.map(room => ({
    ...room,
    isAvailable: Boolean(room.isAvailable),
    roomValue: ROOM_TYPE_MAP[room.roomValue],
  }));
}
